var _module = require('../components/module');

/*
removeNonGeocded
Takes a collection of results and filters out
ones without any lat lon data
*/

_module.filter('removeNonGeocoded', function () {
    return function removeNonGeocoded(results) {
        if(angular.isArray(results) && results.length > 0){
            var r = results.filter(function (res) {
                return res.lat && res.lon && res.lat !== '0' && res.lon !== '0';
            });
        }

        return r || [];
    };
});
